import { InformationCircleIcon } from '@heroicons/react/24/outline';
import { twMerge } from 'tailwind-merge';
import ConditionalRenderer from '../ConditionalRenderer';
import { Tooltip } from '../dataDisplay/Tooltip';

export type LabelPosition = 'inside' | 'outside';
export type LabelProps =
  | string
  | {
      text: string;
      className?: string;
      position?: LabelPosition;
      info?: string;
    };

const Label = ({ label, htmlFor }: { label: LabelProps; htmlFor?: string }) => {
  const labelProps = normalizeProps(label);

  const position = {
    outside: 'absolute bottom-full',
    inside: '',
  };

  const classname = twMerge(
    'font-500 whitespace-nowrap',
    labelProps.className,
    position[labelProps.position || 'inside'],
  );

  const info = labelProps.info;

  return (
    <label
      htmlFor={htmlFor}
      className={twMerge('relative flex items-center gap-1', classname)}
    >
      {labelProps.text}
      <ConditionalRenderer condition={info}>
        <Tooltip text={info} placement="right" className="max-w-md">
          <InformationCircleIcon className="w-4 h-4 mb-0.5 text-primary" />
        </Tooltip>
      </ConditionalRenderer>
    </label>
  );
};

export default Label;

export const labelCssModifier = (label?: LabelProps) => {
  if (!label) return '';
  const labelProps = normalizeProps(label);
  if (labelProps.position !== 'outside') return '';
  return 'relative before:h-4 before:content-normal ';
};

const normalizeProps = (label: LabelProps) => {
  if (typeof label === 'string') {
    return { text: label };
  }
  return label;
};
